/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2022
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class InAppSlideoutAPI
 * @hideconstructor
 * @classdesc Internal API class that is used to manage the InAppSlideout view.
 */
define([], () => {
	class InAppSlideoutAPI {

		/**
		 * @function InAppSlideoutStateAPI#registerContribution
		 * @description register a slideout contribution
		 * @param {string} id - id of the contribution
		 * @param {Object} contentContribution - content contribution
		 * @return {Promise} Promise resolved when the contributor is registered
		 */
		registerContribution() {}

		/**
		 * @function InAppSlideoutStateAPI#removeContribution
		 * @description remove a slideout contribution
		 * @param {string} id - id of contribution to remove
		 */
		removeContribution() {}

		/**
		 * @function InAppSlideoutStateAPI#getContributions
		 * @description get the list of contributions
		 * @return {Object[]} list of contributions
		 */
		getContributions() {}

		/**
		 * @function InAppSlideoutStateAPI#getContribution
		 * @description get a single contribution by id
		 * @param {string} id - id of the contribution
		 * @return {Object} contribution object
		 */
		getContribution() {}

		/**
		 * @function InAppSlideoutStateAPI#getCurrent
		 * @description get current contribution
		 * @return {Object} object containing `item` (contribution instance) and `data` (additional data to pass the contribution upon render)
		 */
		getCurrent() {}

		/**
		 * @function InAppSlideoutStateAPI#getUiState
		 * @description get the current ui state
		 * @return {Object}
		 */
		getUiState() {}

		/**
		 * @function InAppSlideoutStateAPI#onStateChange
		 * @description register a on state change callback, to be called when the state is changed
		 * @param {Function} fn - function to be called when the state changes
		 * @return {Function} function returned to destroy remove the listener
		 */
		onStateChange() {}

		/**
		 * @function InAppSlideoutStateAPI#isOpen
		 * @description Check whether the in app slideout is open or not
		 * @return {Boolean} TRUE if the slideout is open and FALSE if the slideout is not
		 */
		isOpen() {}

		/**
		 * @function InAppSlideoutStateAPI#open
		 * @description Open the slideout
		 * @param {String} id Unique contribution identifier to open a slideout contribution
		 */
		open() {}

		/**
		 * @function InAppSlideoutStateAPI#close
		 * @description Close the slideout
		 */
		close() {}
	}

	return InAppSlideoutAPI;
});
